module.exports = __webpack_public_path__ + "img/olho-visualizacao.e3dd299c.svg";